import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';
import { TypedFormGroup, TypedFormControl } from '@principle-theorem/ng-shared';
import {
  IAccSoftTissueInjury,
  AccSoftTissueHow,
} from '@principle-theorem/principle-core/interfaces';
import { filterUndefined } from '@principle-theorem/shared';
import { hasRequiredError } from './form-group-helpers';

export class AccSoftTissueInjuryFormGroup extends TypedFormGroup<IAccSoftTissueInjury> {
  constructor() {
    super({
      how: new TypedFormControl<AccSoftTissueHow[]>(undefined),
      positionInMouth: new TypedFormControl<string>(undefined),
    });

    this.positionInMouth.disable();
    this._setupValidationHandlers();
  }

  get how(): TypedFormControl<AccSoftTissueHow[]> {
    return this.controls.how as TypedFormControl<AccSoftTissueHow[]>;
  }

  get positionInMouth(): TypedFormControl<string> {
    return this.controls.positionInMouth as TypedFormControl<string>;
  }

  get hasHowSelection(): boolean {
    return (this.how.value?.length ?? 0) > 0;
  }

  get positionInMouthRequiredError(): boolean {
    return hasRequiredError(this.controls.positionInMouth);
  }

  private _setupValidationHandlers(): void {
    this.controls.how.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) => {
        if (value.length > 0) {
          this.positionInMouth.setValidators([
            Validators.required,
            Validators.maxLength(100),
          ]);
          this.positionInMouth.enable();
          this.positionInMouth.updateValueAndValidity();
        } else {
          this.positionInMouth.reset();
          this.positionInMouth.clearValidators();
          this.positionInMouth.disable();
        }
      });
  }
}
